import { useField } from "formik";
import { useSelector } from 'react-redux';
import Flex from '@react-css/flex'
import './field.css'
import { Input as AntInput } from 'antd';

export const Input = (props) => {

    const {
        hasErrorInitial,
        disabled,
        isLoading: propsLoading,
        style,
        ...inputProps
    } = props

    const [field, meta, helpers] = useField(props.name);
    const { isGlobalLoading, isAccountLoading, isRefreshAccount, hasError: anyError } = useSelector(state => state.dashboard);
    const isLoading = isGlobalLoading || propsLoading || isAccountLoading || isRefreshAccount;
    let status = hasErrorInitial ? 'error' : false;

    if ((anyError || meta.touched) && meta.error && !props.disabled) {
        status = 'error'
    }

    const handleChange = (evt) => {
        helpers.setValue(evt.target.value ?? '');
    };

    return (
        <>
            <Flex column >
                <AntInput
                    {...inputProps}
                    name={field.name}
                    onBlur={field.onBlur}
                    style={{ maxWidth: 320, ...style }}
                    allowClear
                    value={meta?.value}
                    status={status}
                    placeholder={"Enter an Input"}
                    disabled={disabled || isLoading}
                    onChange={handleChange}
                    autoComplete="none"
                />
                {status &&
                    <Flex>
                        <p className="required-label">
                            {meta.error}
                        </p>
                    </Flex>
                }
            </Flex>
        </>
    )
}
